<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <el-dialog
        title=""
        :visible.sync="beforeAddQuestionDialog"
        width="620px"
        center
      >
        <br />
        <div class="type-font">请选择试题录入方式</div>
        <br />
        <div class="question-type-ctn">
          <div
            @click="switchImportType(key, item)"
            :class="item.class01"
            v-for="(item, key) in constant.tabs03"
            :key="key"
          >
            <span>{{ item.text }}</span>
          </div>
        </div>
        <br />
        <!-- <div>
          试题默认标签：<el-tag>冒险岛</el-tag>
          <br>
          <div style="margin-top: 1rem;">
            <span style="color: transparent;">试题默认标签：</span>
            <el-select
              allow-create
              default-first-option
              popper-class="tags-wrapper01"
              multiple
              filterable
              remote
              :remote-method="getTags"
              :loading="tagsLoading"
              v-model="questionTag"
              placeholder="搜索标签（可输入新标签名后按回车以新建）"
              style="width: 300px;"
            >
              <el-option
                v-for="item in questionTags" :key="item.value"
                :label="item.label"
                :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">
                  <el-link type="primary"  @click.stop="removeTag(item)" >
                    <i class="el-icon-edit el-icon--right"></i>
                  </el-link>
                  <span style="color: transparent;">s</span>
                  <el-link type="danger"  @click.stop="removeTag(item)" >
                    <i class="el-icon-delete el-icon--right"></i>
                  </el-link>
                </span>
              </el-option>
            </el-select>
            &nbsp;
            <el-button type="primary">确认添加</el-button>
          </div>
        </div> -->
        <span slot="footer" style="text-align: center">
          <el-button @click="beforeAddQuestionDialog = false">取 消</el-button>
          <el-button type="primary" @click="goCreateSurvey">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="" :visible.sync="showDialog" width="30%" center>
        <deptTree :value.sync="value" :visible.sync="showDialog"></deptTree>
      </el-dialog>
      <el-dialog
        title="高级筛选"
        :visible.sync="dialogVisible"
        :close-on-click-modal="true"
        :modal="true"
        :show-close="true"
        :center="true"
      >
        <el-form
          style="margin-left: 20%"
          label-position="right"
          label-width="80px"
        >
          <el-form-item label="题    型">
            <el-select
              v-model="tx_dmms"
              @change="seleteGet"
              style="width: 240px"
            >
              <el-option
                v-for="item in typeOfQuestionItem"
                :key="item.dmz"
                :label="item.dmms"
                :value="item.dmz"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="试题分类">
            <classify
              :value.sync="form.flbhList"
              type="questions"
              :multiple="true"
              style="width: 180px"
            >
            </classify>
            &nbsp;
            <el-button @click="showDialog1 = true">筛选</el-button>
            <el-dialog
              title="选择试题分类"
              :visible.sync="showDialog1"
              :append-to-body="true"
              top="10vh"
              width="30%"
              center
            >
              <classifyTree
                :value.sync="form.flbhList"
                type="questions"
                :visible.sync="showDialog1"
              ></classifyTree>
            </el-dialog>
          </el-form-item>
          <el-form-item label="难  度">
            <input
              type="checkbox"
              class="queTypeItem"
              id="nycdj"
              value="1"
              v-model="course"
              style="
                width: 40px;
                margin: 3px 5px 5px 5px;
                position: relative;
                display: inline-block;
                padding: 7px;
                background-color: #fafafa;
                border-radius: 3px;
                border: 1px solid #cacaca;
                margin-right: 0;
              "
            />简单
            <input
              type="checkbox"
              class="queTypeItem"
              id="nycdp"
              value="2"
              v-model="course"
              style="
                width: 40px;
                margin: 3px 5px 5px 5px;
                position: relative;
                display: inline-block;
                padding: 7px;
                background-color: #fafafa;
                border-radius: 3px;
                border: 1px solid #cacaca;
                margin-right: 0;
              "
            />普通
            <input
              type="checkbox"
              class="queTypeItem"
              id="nycdk"
              value="3"
              v-model="course"
              style="
                width: 40px;
                margin: 3px 5px 5px 5px;
                position: relative;
                display: inline-block;
                padding: 7px;
                background-color: #fafafa;
                border-radius: 3px;
                border: 1px solid #cacaca;
                margin-right: 0;
              "
            />困难
            <!-- <el-checkbox v-model="course" value="1" >简单</el-checkbox> -->
          </el-form-item>
          <el-form-item label="创建人">
            <el-input
              v-model="cjr"
              placeholder="请输入创建人名称"
              style="width: 240px"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="query()">查 询</el-button>
        </span>
      </el-dialog>
      <div class="table-global mar-bottom-10 pad-bottom-0">
        <el-form :inline="true" :model="form" @submit.native.prevent>
          <el-row>
            <el-col :span="12" style="text-align: left">
              <el-form-item label="">
                <el-input
                  v-model="tg"
                  style="width: 400px"
                  placeholder="请输入试题题干"
                  @keyup.enter.native="query()"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="query()" id="query"
                  >查询</el-button
                >
              </el-form-item>
              <el-button type="text" @click="dialogVisible = true"
                >高级筛选</el-button
              >
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-form-item>
                <el-button
                  type="primary"
                  style="color: white"
                  @click="beforeAddQuestionDialog = true"
                >
                  <i class="el-icon-plus">&emsp;添加试题</i>
                </el-button>
                <el-button
                  @click="handleRemoveAll"
                  id="sc"
                  :disabled="!lshStr.length > 0"
                >
                  批量删除
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  @click="editDialogVisible = true"
                  id="gx"
                  :disabled="!lshStr.length > 0"
                >
                  批量更新
                </el-button>
                <el-dialog
                  title="批量更新"
                  :visible.sync="editDialogVisible"
                  :close-on-click-modal="true"
                  :modal="true"
                  :show-close="true"
                  :center="true"
                  style="right: 30%"
                >
                  <div id="" align="center">
                    <el-form-item label="试题分类" prop="gwid">
                      <el-select
                        v-model="form.flbh"
                        style="width: 220px"
                        placeholder="请选择试题分类"
                      >
                        <el-option
                          key="flbh"
                          :value="form.flbh"
                          :label="flmc"
                          style="height: auto"
                        >
                          <el-tree
                            :data="fldata"
                            default-expand-all
                            node-key="gwid"
                            ref="tree"
                            highlight-current
                            :props="defaultProps2"
                            @node-click="handleNodeClick"
                          >
                          </el-tree>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div id="" align="center">
                    <span>难度</span>
                    <input
                      type="radio"
                      class="queTypeItem"
                      id="nycdj"
                      value="1"
                      v-model="course1"
                      style="width: 40px"
                    />简单
                    <input
                      type="radio"
                      class="queTypeItem"
                      id="nycdp"
                      value="2"
                      v-model="course1"
                      style="width: 40px"
                    />普通
                    <input
                      type="radio"
                      class="queTypeItem"
                      id="nycdk"
                      value="3"
                      v-model="course1"
                      style="width: 40px"
                    />困难
                    <!-- <el-checkbox v-model="course" value="1" >简单</el-checkbox> -->
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false"
                      >取 消</el-button
                    >
                    <el-button type="primary" @click="handleUpdateAll()"
                      >确 定</el-button
                    >
                  </span>
                </el-dialog>
              </el-form-item>
              <!--
            <el-form-item>
              <el-button type="primary" style="color: white;"  @click="goCc">
                <i >试题查重</i>
              </el-button>
            </el-form-item>
            -->
              <el-form-item>
                <el-button
                  type="warning"
                  style="color: white"
                  @click="flgldialogVisible = true"
                >
                  试题分类管理
                </el-button>
                <el-dialog
                  title="编辑分类"
                  :visible.sync="flgldialogVisible"
                  width="40%"
                  center
                  :close-on-click-modal="false"
                >
                  <classifyTreeEdit
                    type="questions"
                    :visible.sync="flgldialogVisible"
                  ></classifyTreeEdit>
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-global">
        <el-table
          :data="tableData"
          type="selection"
          style="width: 100%"
          :border="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            prop="stid"
          ></el-table-column>
          <el-table-column
            label="题型"
            width="100"
            prop="txmc"
          ></el-table-column>
          <el-table-column label="试题分类" width="130" prop="flmc" />
          <el-table-column label="试题内容" width="300">
            <template slot-scope="scope">
              <el-col
                style="
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                :span="22"
                v-html="scope.row.tg || '&nbsp;'"
              ></el-col>
              <el-col :span="2">
                <el-popover trigger="hover" placement="top">
                  <div
                    style="max-width: 1000px"
                    v-if="scope.row.stnr"
                    class="editorHtml"
                    v-html="scope.row.stnr"
                  ></div>
                  <pre
                    style="max-width: 1000px"
                    v-else
                    v-html="scope.row.tg"
                  ></pre>
                  <i slot="reference" class="el-icon-more"></i>
                </el-popover>
              </el-col>
            </template>
          </el-table-column>
          <el-table-column label="难度" width="100" prop="ndmc" />
          <el-table-column label="创建人" width="120" prop="yhmc" />
          <el-table-column label="创建时间" width="155" prop="cjsj" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleUpdate(scope.$index, scope.row.stid)"
                type="danger"
                style="background: white; border-color: blue; color: black"
              >
                编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleRemove(scope.$index, scope.row.stid)"
                type="danger"
              >
                删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import * as questions from '@/api/questions'
import { getTypeOfQuestion } from '@/api/questions'
import classifyTree from '@/components/tree/classifyTree'
import classifyTreeEdit from '@/components/tree/classifyTreeEdit'
import classify from '@/components/select/classify'
import constant from '../../assets/js/constant'
export default {
  data () {
    return {
      currentImportType: '',
      tagsLoading: false,
      questionTag: '',
      questionTags: [],
      constant,
      beforeAddQuestionDialog: false,
      value: 1,
      fldh: '',
      flmc: '',
      showDialog: false,
      showDialog1: false,
      form: {
        ksmc: '',
        flbh: '',
        flbhList: []
      },
      dialogVisible: false, // 高级筛选弹出框
      flgldialogVisible: false, // 分类管理弹出框
      editDialogVisible: false, // 批量修改弹出框
      dialogStfl: false,
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: [],
      course: [],
      course1: [],
      nds: [],
      tx: [],
      tx_dmz: '',
      tx_dmms: '',
      cjr: '',
      tg: '',
      typeOfQuestionItem: [],
      fldata: [], // 分类数据
      newApiGroupName: '',
      defaultProps: {
        children: 'children',
        flmc: 'flmc', // 分类管理
        sjfl: 'sjfl'
      }, // 树控件后台数据显示
      defaultProps2: {
        children: 'children',
        label: 'flmc' // 新增分类选择器
      }, // 树控件后台数据显示
      // 岗位树形结构添加一级节点所需数据
      treeSetData1: {
        defaultExpandAll: true, // 是否默认展开
        treeData: [], // 树形组件数据集
        // 添加树形数据数组内容
        addList: [],
        // 是否添加flg
        addNodeFlg: false,
        // 默认的id
        defaultId: 1000,
        // 新增的最外层节点名称
        newName: '',
        tree_key: 0,
        pid: 0
      },
      lshStr: ''
    }
  },
  components: {
    myHeader,
    classify,
    classifyTree,
    classifyTreeEdit
  },
  methods: {
    async getTags (keyword) {
      if (keyword !== '') {
        this.tagsLoading = true
        setTimeout(() => {
          this.tagsLoading = false
          this.questionTags = this.constant.tagList.filter(item => {
            return item.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.questionTags = this.constant.tagList
      }
    },
    removeTag (item) {
      console.log(item)
    },
    switchImportType (key, item) {
      this.currentImportType = item.type
      for (let i = 0; i < this.constant.tabs03.length; i++) {
        if (key === i) {
          this.constant.tabs03[i].class01 = 'type-clicked'
        } else {
          this.constant.tabs03[i].class01 = 'type-unclicked'
        }
      }
    },
    // 复选框选中状态改变
    handleSelectionChange (row) {
      // console.log(row)
      this.lshStr = ''
      row.forEach((value, index) => {
        if (index === 0) {
          this.lshStr += value.stid
          // console.log(value.stid)
        } else {
          this.lshStr += ',' + value.stid
        }
      })
      if (this.lshStr.length === 0) {
      }
    },
    // 获取选择题型dmz
    seleteGet (vid) {
      let obj = {}
      obj = this.typeOfQuestionItem.find(item => {
        return item.dmz === vid
      })
      this.tx_dmz = obj.dmz
      this.tx_dmms = obj.dmms
    },
    // 添加试题
    goCreateSurvey () {
      if (this.currentImportType === 'text') {
        const blank = this.$router.resolve({
          path: '/questions/textAdd',
          query: {
            tags: '1,2,3,4'
          }
        })
        window.open(blank.href, '_blank')
        return
      }

      this.$router.push({
        path: '/questions/add',
        query: {
          tags: '1,2,3,4',
          importType: this.currentImportType
        }
      })
    },
    // 试题查重
    goCc () {
      this.$router.push({
        path: '/questions/cc'
      })
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 选择某个分类
    handleNodeClick (fldata) {
      this.flbh = fldata.flbh
      this.flmc = fldata.flmc
      this.sjfl = fldata.sjfl
      this.form.flbh = fldata.flbh
    },
    // 查询
    query (currentPage = 1) {
      this.dialogVisible = false
      this.currentPage = currentPage
      var nds = this.course.join(',')
      const params = Object.assign({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        nd: nds,
        tx: this.tx_dmz
      })
      params.flbhs = this.form.flbhList.join(',')
      params.cjr = this.cjr
      params.tg = this.tg
      questions.getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
        })
      })
      questions.getClassifyList().then(res => {
        this.$http.callback(res, () => {
          this.parseTree(res.data)
          // this.treeSetData.treeData = this.parseTree(res.data)
          // console.log(this.treeSetData.treeData)
        })
      })
      getTypeOfQuestion().then(res => {
        this.typeOfQuestionItem = res.data
      })
    },
    // 将数据转成成树形结构
    parseTree (list) {
      const temp = {}
      const tree = {}
      // 数组转 键值对
      list.forEach(flObj => {
        temp[flObj.flbh] = flObj
      })
      for (const flbh in temp) {
        const fl = temp[flbh]
        const sjflObj = temp[fl.sjfl]
        if (sjflObj) {
          if (!sjflObj.children) {
            sjflObj.children = []
          }
          sjflObj.children.push(fl)
        } else {
          tree[flbh] = fl
        }
      }
      this.fldata = Object.keys(tree).map(key => tree[key])
    },
    // 修改
    handleUpdate ($index, stid) {
      const params = {
        stid: stid,
        importType: 'manual',
        type: 'edit'
      }
      this.$router.push({
        path: '/questions/add',
        query: params
      })
    },
    // 批量更新
    handleUpdateAll () {
      this.editDialogVisible = false
      var nds = this.course1
      const params = {
        id: this.lshStr,
        nd: nds,
        flhb: this.form.flbh
      }
      questions.batchEditQuestion(params).then(res => {
        this.$http.callback(res, () => {
          this.$message.success(res.msg)
          this.query(this.currentPage)

          // questions.getList(params1).then(res => {
          //   this.$http.callback(res, () => {
          //     const data = res.data
          //     this.tableData = data.list
          //     this.totalNum = data.count
          //   })
          // })
        })
      })
    },
    // 删除
    handleRemove ($index, row) {
      this.$confirm('确定需要删除选中试题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row
        }
        questions.remove(params).then(res => {
          this.$http.callback(res, () => {
            this.$message.success(res.msg)
            this.query(this.currentPage)
          })
        })
      })
    },
    // 批量删除
    handleRemoveAll () {
      this.$confirm('确定需要删除选中试题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: this.lshStr
        }
        questions.remove(params).then(res => {
          this.$http.callback(res, () => {
            this.$message.success(res.msg)
            this.query(this.currentPage)
          })
        })
      })
    }
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
    const typeIndex = 0
    this.switchImportType(typeIndex, constant.tabs03[typeIndex])
  }
}
</script>
<style lang="less">
.button_color {
  border-color: #00f;
  color: #00f;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 20px;
}
.el-message-box {
  width: 450px;
}
.button-style {
  padding: 0px;
}
.input-style {
  height: 15px;
  width: 140px;
}
.through-panel-body {
  padding-top: 12px;
  width: 100%;
  display: flex;
  .panel-area-left {
    position: relative;
    width: 360px;
    border: 2px solid rgba(240, 240, 240, 1);
    border-radius: 5px;
    .head-title {
      display: flex;
      justify-content: space-between;
      padding: 10px 10px;
      h5 {
        border-left: solid 3px #fb8742;
        padding-left: 5px;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
      }
    }
    .area-tree {
      width: 100%;
      .tree-style {
        margin: 0px 0px 10px 10px;
        height: 88%;
        overflow-y: auto;
      }
      .el-tree-node__content {
        padding-left: 10px;
        display: flex;
        width: 100%;
        .tree-span {
          display: flex;
          width: 100%;
          .tree_node_op {
            margin-left: 80px;
            background-color: turquoise;
            display: inline;
          }
        }
      }
    }
    .add_question {
      margin: 10px 0px;
    }
    .foot-style {
      padding-right: 5px;
      height: 40px;
      text-align: right;
    }
  }
  .panel-area-right {
    margin-right: 5px;
    width: 100%;
    padding-left: 15px;
    height: 100%;
    .el-row {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .located-class {
        width: 50%;
      }
      .device-floor-class {
        width: 50%;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
/*首先第一步就是隐藏原来的复选框*/
.regular-checkbox {
  display: none;
}
/*第二部定义现在复选框样式*/
.regular-checkbox + label {
  position: relative;
  display: inline-block;
  /*lable是内联元素所以需要加inline-block*/
  padding: 7px;
  /*设置复选框大小*/
  background-color: #fafafa;
  /*设置背景颜色*/
  border-radius: 3px;
  /*复选框border*/
  border: 1px solid #cacaca;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  /*创建的阴影效果  这里需要了解box-shadow的属性，前三个值分别是
    阴影离开横方向的距离   :offset-x
    阴影离开纵方向的距离   ：offset-y
    阴影的模糊半径：
    阴影的颜色
  */
}
/*第三部分做一个active的效果*/
.regular-checkbox + label:active,
.regular-checkbox + label:checked + label:active {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}
/*选中之后的样式*/
.regular-checkbox:checked + label {
  background-color: #e9ecee;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
/*选中后的效果*/
.regular-checkbox:checked + label:after {
  content: '\2714';
  /*这是一个对勾*/
  position: absolute;
  font-size: 12px;
  /*设置对勾的大小*/
  top: 0px;
  left: 2px;
  /*设置位置的偏向*/
  color: #009900;
  /*设置颜色绿色*/
  font-weight: bold;
  /*设置对勾的粗细*/
}
</style>

<style lang="less" scoped>
.type-font {
  text-align: center;
  color: rgba(6, 6, 6, 0.45);
  font-size: 18px;
  font-weight: 700;
}
.question-type-ctn {
  display: flex;
  height: 100%;
  justify-content: space-between;

  div {
    width: 165px;
    height: 45px;
    border-radius: 6px;
    color: #333;
    font-size: 16px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.type-clicked {
  cursor: pointer;
  background: #3d6bff;
  span {
    color: #fff;
  }
}

.type-unclicked {
  background: #e5e5e5;
  cursor: pointer;
  color: #666;
  font-weight: 350;
  &:hover {
    background: #eaeaea;
  }
}
</style>

<style lang="less">
.tags-wrapper01 {
  .el-select-dropdown__item {
    padding: 0 15px;
    &.selected::after {
      right: 70px !important;
    }
  }
}
</style>
